import classNames from 'classnames'
import { BaseModalFooter } from '../base-modal'
import styles from './ModalSheetFooter.module.scss'
import type { ModalSheetFooterProps } from './types'

const ModalSheetFooter = ({ className, children, ...props }: ModalSheetFooterProps) => {
  return (
    <BaseModalFooter
      className={classNames(styles['pintxo-modal-sheet__footer'], className)}
      {...props}
    >
      {children}
    </BaseModalFooter>
  )
}
export default ModalSheetFooter
